const InfoIcon = () => {
  return (
    <svg
      width="69"
      height="69"
      viewBox="0 0 69 69"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34.5 51.7571V51.7917M34.5 17.2083V41.4167M65.625 34.5C65.625 51.69 51.69 65.625 34.5 65.625C17.3101 65.625 3.375 51.69 3.375 34.5C3.375 17.3101 17.3101 3.375 34.5 3.375C51.69 3.375 65.625 17.3101 65.625 34.5Z"
        stroke="#1EA0C9"
        strokeWidth="5.1875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default InfoIcon;
